module.exports = __webpack_public_path__ + "static/media/THD_logo.eaf2337c.jpg";